import React from 'react';
import { useDimensionsRef } from 'rooks';

export const useScrollableContainer = (recalculateScrollDeps: any[]) => {
  const [scrollable, setScrollable] = React.useState(false);
  const [scrollContainerRef, dimensions, node] = useDimensionsRef({ updateOnResize: true });

  React.useEffect(() => {
    const clientHeight = node?.clientHeight ?? 0;
    const scrollHeight = node?.scrollHeight ?? 0;
    setScrollable(scrollHeight > clientHeight);
  }, [dimensions, node, ...recalculateScrollDeps]);

  return [scrollContainerRef, scrollable];
};
